var bindsToCust = { vm: '=' };
var ReportingCustomController = (function () {
    function ReportingCustomController($scope, env, $filter, $timeout, $q, socket, DTS, DTOptionsBuilder, DTColumnBuilder, _, $compile, $state, $stateParams, notify, Dialog, settings) {
        var _this = this;
        this.$scope = $scope;
        this.env = env;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this._ = _;
        this.$compile = $compile;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.visibleCustom = false;
        this.newSearch = 'Default';
        this.filterList = {};
        this.isRowIdpresent = false;
        this.repType = 'OPP';
        this.filterType = 'current';
        this.showTable = false;
        this.dtInstance = {};
        this.showasync = false;
        this.asyncColumns = [];
        this.pendingSearch = angular.noop;
        this.cancelSearch = angular.noop;
        this.cachedQuery = {};
        this.lastSearch = {};
        this.isCustomReady = false;
        //this.allContacts = this.loadContacts();
        this.filterSelected = true;
        //    let querySearch = this.querySearch;
        //    let delayedQuerySearch = this.delayedQuerySearch;
        // datatable related
        this.currFilter = [];
        this.dynamicColumns = [];
        this.checkBoxModel = {};
        this.isDownloading = false;
        this.filters = {};
        this.filterIots = [];
        this.filterImts = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterStatuses = [];
        this.filterSubStatuses = [];
        this.filterOwners = [];
        this.teams = [];
        this.filterTeams = [];
        this.vapFilter = false;
        this.showFilterBtn = false;
        this.tableDependencies = [];
        this.reportIsLoading = false;
        this.overLimit = false;
        this.listColumns = [];
        this.visibleCustomList = false;
        this.opptyIdList = '';
        this.mandatoryRoWIDtblName = [];
        this.sviFromDate = null;
        this.sviToDate = null;
        this.db2Col = [];
        this.genCol = [];
        this.eligCol = [];
        this.valCol = [];
        this.rowIdItem = {};
        this.oppItem = {};
        this.colQty = 0;
        this.chosenColumns = [];
        this.filterDetails();
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                _this.allTeams = [];
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
            }
        });
        this.socket.forward('reporting.dynamicColumns', this.$scope);
        this.$scope.$on('socket:reporting.dynamicColumns', function (event, data) {
            _this.dynamicColumns = data.columns.columnArr;
            _this.dynamicColumns.forEach(function (oneCol) {
                oneCol['isSelected'] = false;
                if (oneCol.dbPlace.substring(0, 3) === 'doc') {
                    if (oneCol.dbPlace.indexOf('valid') > -1) {
                        _this.valCol.push(oneCol);
                    }
                    else if (oneCol.dbPlace.indexOf('gpp') > -1 || oneCol.dbPlace.indexOf('goe') > -1) {
                        _this.eligCol.push(oneCol);
                    }
                    else {
                        _this.genCol.push(oneCol);
                    }
                }
                else {
                    _this.db2Col.push(oneCol);
                    if (_this.db2Col[_this.db2Col.length - 1].name === 'ROW_ID') {
                        if (_this.repType === 'ROW_ID' && !_this.db2Col[_this.db2Col.length - 1].isSelected) {
                            _this.colQty++;
                            _this.db2Col[_this.db2Col.length - 1].isSelected = true;
                        }
                        _this.rowIdItem = _this.db2Col[_this.db2Col.length - 1];
                        _this.isRowIdpresent = _this.rowIdItem.isSelected;
                    }
                    else if (_this.db2Col[_this.db2Col.length - 1].name === 'OPP') {
                        if (_this.repType === 'OPP' && !_this.db2Col[_this.db2Col.length - 1].isSelected) {
                            _this.colQty++;
                            _this.db2Col[_this.db2Col.length - 1].isSelected = true;
                        }
                        _this.oppItem = _this.db2Col[_this.db2Col.length - 1];
                    }
                }
            });
            _this.tableDependencies = data.columns.tableDependencies;
            for (var i = 0; i < _this.tableDependencies.length; i++) {
                if (_this.tableDependencies[i].needsRowId) {
                    _this.mandatoryRoWIDtblName.push(_this.tableDependencies[i].tblName);
                }
            }
            _this.isCustomReady = true;
        });
        this.socket.forward('filters.getUserFilters', this.$scope);
        this.$scope.$on('socket:filters.getUserFilters', function (event, data) {
            _this.userFilters = data;
            _this.filtersExist = true;
        });
        this.socket.forward('filters.deleteProfiles', this.$scope);
        this.$scope.$on('socket:filters.deleteProfiles', function (event, data) {
            _this.userFilters = data;
            _this.allowed = false;
        });
        this.socket.forward('report.customFailed', this.$scope);
        this.$scope.$on('socket:report.customFailed', function (event, data) {
            _this.reportIsLoading = false;
        });
        this.socket.forward('report.customCreated', this.$scope);
        this.$scope.$on('socket:report.customCreated', function (event, data) {
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    type: 'application/vnd.openxmlformats'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-Custom-Report_" + d + ".xlsx");
                a.click();
            }
            else {
                _this.overLimit = true;
                alert('Report is over 100 000 entries, please refine your search.');
            }
            _this.reportIsLoading = false;
        });
    }
    ReportingCustomController.prototype.$OnInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'FetchSavedFilters',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                email: this.env.user.email
            }
        });
    };
    ReportingCustomController.prototype.cloudantTest = function () {
        var test = this.opptyIdList.split(',');
        for (var key in test) {
            test[key] = test[key].trim();
        }
        // console.log(test);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'parseCloudant',
                script: '/reporting/custom-cloudant-reporting',
                user: this.env.user,
                email: this.env.user.email,
                opptys: test,
                excelBase: {
                    cols: [],
                    rows: []
                }
            }
        });
    };
    ReportingCustomController.prototype.checkboxChange = function (oneItem) {
        if (oneItem.isSelected) {
            this.colQty++;
        }
        else {
            this.colQty--;
        }
    };
    ReportingCustomController.prototype.repTypeChange = function () {
        if (this.repType === 'OPP' && !this.oppItem.isSelected) {
            this.oppItem.isSelected = true;
            this.colQty++;
        }
        else if (!this.rowIdItem.isSelected) {
            this.rowIdItem.isSelected = true;
            this.colQty++;
        }
    };
    ReportingCustomController.prototype.toggleCustom = function () {
        this.filterToggles = {
            countries: true,
            dmtSubStats: true,
            dmtStats: true,
            sviStats: true,
            teams: false,
            vap: true
        };
        if (this.visibleCustom) {
            this.visibleCustom = false;
        }
        else {
            this.visibleCustom = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getDynamicColumns',
                    script: '/reporting/reporting',
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'FetchSavedFilters',
                    script: '/queueservice/filterprofiles',
                    user: this.env.user,
                    email: this.env.user.email
                }
            });
        }
    };
    ReportingCustomController.prototype.viewProfiles = function (ev) {
        this.Dialog.openDialog2(ev, '', ReportingCustomController, 'report-custom-profiles.html', '', this.$scope); //FilterController
    };
    ReportingCustomController.prototype.toggleCustomList = function () {
        this.visibleCustomList = !this.visibleCustomList;
    };
    ReportingCustomController.prototype.createCustom = function () {
        this.showasync = !this.showasync;
    };
    ReportingCustomController.prototype.generateReport = function (action) {
        var that = this;
        this.chosenColumns = [];
        var rowIdObj = this.rowIdItem;
        this.isRowIdpresent = this.rowIdItem.isSelected;
        var shouldRowIdBePresent = false;
        for (var i = 0; i < this.db2Col.length; i++) {
            if (this.db2Col[i].isSelected) {
                this.chosenColumns.push(this.db2Col[i]);
                if (this.mandatoryRoWIDtblName.indexOf(this.db2Col[i].dbPlace) > -1) {
                    shouldRowIdBePresent = true;
                }
            }
        }
        var includesCloudant = false;
        for (var i = 0; i < this.genCol.length; i++) {
            if (this.genCol[i].isSelected) {
                this.chosenColumns.push(this.genCol[i]);
                includesCloudant = true;
            }
        }
        for (var i = 0; i < this.eligCol.length; i++) {
            if (this.eligCol[i].isSelected) {
                this.chosenColumns.push(this.eligCol[i]);
                includesCloudant = true;
            }
        }
        for (var i = 0; i < this.valCol.length; i++) {
            if (this.valCol[i].isSelected) {
                this.chosenColumns.push(this.valCol[i]);
                includesCloudant = true;
            }
        }
        if (shouldRowIdBePresent && !this.isRowIdpresent) {
            //this.chosenColumns.unshift(rowIdObj);
            this.chosenColumns.splice(1, 0, rowIdObj);
            this.isRowIdpresent = true;
            this.rowIdItem.isSelected = true;
        }
        that.filterList.vapFilter = that.vapFilter;
        that.filterList.filterSubStatuses = that.filterSubStatuses;
        that.filterList.filterStatuses = that.filterStatuses;
        that.filterList.filterOwners = that.filterOwners;
        that.filterList.filterCountries = that.filterCountries;
        that.filterList.filterSviStatuses = that.filterSviStatuses;
        //that.filterList.filterTeams = that.filterTeams;
        that.filterList.filterImts = that.filterImts;
        that.filterList.filterIots = that.filterIots;
        if (this.sviFromDate === null) {
            that.filterList.sviFromDate = '';
        }
        else {
            that.filterList.sviFromDate = this.sviFromDate.getFullYear() + '-' + (this.sviFromDate.getMonth() + 1) + '-' + this.sviFromDate.getDate();
        }
        if (this.sviToDate === null) {
            that.filterList.sviToDate = '';
        }
        else {
            that.filterList.sviToDate = this.sviToDate.getFullYear() + '-' + (this.sviToDate.getMonth() + 1) + '-' + this.sviToDate.getDate();
        }
        that.overLimit = false; //reset
        var data = {
            dlVsDispl: action,
            repType: that.repType,
            tableDependencies: that.tableDependencies,
            chosenColumns: this.chosenColumns,
            filterList: that.filterList,
            filterType: this.filterType,
            user: this.env.user.email,
            isRowIdpresent: this.isRowIdpresent,
            includesCloudant: includesCloudant
        };
        if (action === 'show' && this.chosenColumns.length <= 20) {
            this.dtColumns = this.buildColumns();
            this.dtOptions = this.DTOptionsBuilder
                .newOptions()
                .withOption('ajax', {
                dataSrc: function (data) {
                    return data.data;
                },
                data: data,
                url: '/api/custom/reporting',
                type: 'POST',
                timeout: 6000000,
                beforeSend: function (request) {
                    request.setRequestHeader('Authorization', 'Bearer ' + that.env.user.token);
                }
            })
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('searchDelay', 1000)
                .withPaginationType('full_numbers')
                .withOption('createdRow', createdRow);
            this.showTable = true;
            function createdRow(row, data, dataIndex) {
                var OFFSET = 3;
                var thresholdDate = new Date();
                thresholdDate.setHours(0, 0, 0, 0);
                thresholdDate.setDate(thresholdDate.getDate() - OFFSET);
                var createdOn = new Date(parseInt(data.created, 10));
                createdOn.setHours(0, 0, 0, 0);
                if (createdOn <= thresholdDate && data.substatus === 'Unassigned') {
                    $(row).addClass('tblRow').css('color', 'red');
                }
                else {
                    $(row).addClass('tblRow');
                }
                var el = angular.element;
                that.$compile(el(row).contents())(that.$scope);
            }
        }
        else if (this.chosenColumns.length <= 20) {
            this.reportIsLoading = true;
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createCustomExcelBackend',
                    script: '/reporting/reporting',
                    data: data,
                    email: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    ReportingCustomController.prototype.applyLastFilter = function () {
        var _this = this;
        // If there is a lastFilter element in user's profile (in browser), set the
        // filters accordingly and apply them rather than loading the default (all)
        if (this.settings.up.lastFilter) {
            angular.forEach(this.settings.up.lastFilter, function (v, k) {
                _this[k] = v;
            });
            this.isFilterToggled = true;
        }
    };
    ReportingCustomController.prototype.addColumns = function () {
        var _this = this;
        this.preparedColumns = [];
        if (this.asyncColumns.size !== 0) {
            this.asyncColumns.forEach(function (item) {
                _this.preparedColumns.push(_this.DTColumnBuilder.newColumn(item.name).withTitle(item.title).withOption('name', item.option));
                return _this.preparedColumns;
            });
        }
    };
    ReportingCustomController.prototype.buildColumns = function () {
        var _this = this;
        var that = this;
        //let columns = this.preparedColumns
        var columns = [];
        this.chosenColumns.forEach(function (oneCol) {
            var title = '';
            var name = '';
            if (oneCol.dbPlace.substring(0, 3) === 'doc') {
                if (oneCol.dbPlace.indexOf('valid') > -1) {
                    title = 'VAL ' + oneCol.title;
                    name = 'VAL_' + oneCol.name;
                }
                else if (oneCol.dbPlace.indexOf('gpp') > -1 || oneCol.dbPlace.indexOf('goe') > -1) {
                    title = 'ELIG ' + oneCol.title;
                    name = 'ELIG_' + oneCol.name;
                }
                else {
                    title = 'GNRL ' + oneCol.title;
                    name = 'GNRL_' + oneCol.name;
                }
            }
            else {
                title = oneCol.title;
                name = oneCol.name;
            }
            columns.push(_this.DTColumnBuilder.newColumn(name).withTitle(title));
        });
        for (var i = 0; i < this.asyncColumns.length; i++) {
        }
        return columns;
    };
    ReportingCustomController.prototype.changeFilters = function (id) {
        var _this = this;
        if (id === 'iot') {
            this.filterImts = [];
            this.filterCountries = [];
            this.filters.imts = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'IMT') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.imts, value.imt_name)) {
                        _this.filters.imts.push(value.imt_name);
                    }
                }
                else if (value.ic === 'Country') {
                    if (_.includes(_this.filterIots, value.imt) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
            this.filters.imts.sort();
            this.filters.countries.sort();
        }
        else if (id === 'imt') {
            this.filterCountries = [];
            this.filters.countries = [];
            this.env.topics.imtFilterValues.forEach(function (value) {
                if (value.ic === 'Country') {
                    if (_.includes(_this.filterImts, value.imt_name) &&
                        !_.includes(_this.filters.countries, value.country)) {
                        _this.filters.countries.push(value.country);
                    }
                }
            });
        }
        // If the 'last used filter' is still active, re-add the values as they will have been lost
        // by the code above
        /*
        if (this.settings.up.lastFilter) {
            this.applyLastFilter(); // reset the values
        }
        */
    };
    ReportingCustomController.prototype.filterDetails = function () {
        var _this = this;
        this.env.topics.imtFilterValues = this.settings.country_list;
        this.filters.iots = this.settings.iot_list;
        this.filters.imts = this.settings.imt_list;
        this.filters.countries = this.settings.getCountryList();
        this.filters.iots.sort();
        this.filters.imts.sort();
        this.filters.countries.sort();
        this.env.topics.imtFilterValues.forEach(function (value) {
            if (value.ic === 'IOT') {
                if (!_.includes(_this.filters.iots, value.imt)) {
                    _this.filters.iots.push(value.imt);
                }
            }
            else if (value.ic === 'IMT') {
                if (!_.includes(_this.filters.imts, value.imt_name)) {
                    _this.filters.imts.push(value.imt_name);
                }
            }
            else {
                if (!_.includes(_this.filters.countries, value.country)) {
                    _this.filters.countries.push(value.country);
                }
            }
        });
        this.filters.sviStatuses = this.settings.svistatuses;
        this.filters.statuses = this.settings.statuses;
        this.filters.subStatuses = this.settings.substatuses;
        this.showFilterBtn = true;
    };
    ReportingCustomController.prototype.applyFilter = function () {
        if (this.filterSubStatuses.length ||
            this.filterTeams.length ||
            this.filterStatuses.length ||
            this.filterCountries.length ||
            this.filterOwners.length ||
            this.filterSviStatuses.length ||
            this.filterImts.length ||
            this.filterIots.length ||
            this.vapFilter) {
            this.isFilterSet = true;
        }
        else {
            this.isFilterSet = false;
        }
        this.dtInstance.DataTable.ajax.reload();
    };
    ReportingCustomController.prototype.clearFilter = function () {
        this.isFilterSet = false;
        this.vapFilter = false;
        this.filterSubStatuses = [];
        this.filterStatuses = [];
        this.filterOwners = [];
        this.filterCountries = [];
        this.filterSviStatuses = [];
        this.filterTeams = [];
        this.filterImts = [];
        this.filterIots = [];
        this.dtInstance.DataTable.ajax.reload();
        delete this.settings.up.lastFilter; //Lose the last filter, too
    };
    ReportingCustomController.prototype.toggleDownload = function () {
        this.isDownloading = true;
    };
    ReportingCustomController.prototype.saveFilter = function () {
        var filterFound = false;
        var dynamicColumns = JSON.parse(JSON.stringify((this.asyncColumns)));
        for (var i = 0; i < dynamicColumns.length; i++) {
            delete dynamicColumns[i].$$hashKey;
        }
        if (typeof this.userFilters !== 'undefined') {
            for (var i = 0; i < this.userFilters.length; i++) {
                if (this.userFilters[i].name === this.newSearch) {
                    filterFound = true;
                    this.userFilters[i].vapFilter = this.vapFilter;
                    this.userFilters[i].filterSubStatuses = this.filterSubStatuses;
                    this.userFilters[i].filterStatuses = this.filterStatuses;
                    this.userFilters[i].filterOwners = this.filterOwners;
                    this.userFilters[i].filterCountries = this.filterCountries;
                    this.userFilters[i].filterSviStatuses = this.filterSviStatuses;
                    this.userFilters[i].filterTeams = this.filterTeams;
                    this.userFilters[i].filterImts = this.filterImts;
                    this.userFilters[i].filterIots = this.filterIots;
                    this.userFilters[i].dynamicColumns = dynamicColumns;
                    this.userFilters[i].repType = this.repType;
                    this.userFilters[i].filterType = this.filterType;
                    this.userFilters[i].sviFromDate = this.sviFromDate;
                    this.userFilters[i].db2Col = this.db2Col;
                    this.userFilters[i].genCol = this.genCol;
                    this.userFilters[i].eligCol = this.eligCol;
                    this.userFilters[i].valCol = this.valCol;
                    break;
                }
            }
        }
        if (!filterFound) {
            var saveSearchObj = {};
            saveSearchObj.name = this.newSearch;
            saveSearchObj.vapFilter = this.vapFilter;
            saveSearchObj.filterSubStatuses = this.filterSubStatuses;
            saveSearchObj.filterStatuses = this.filterStatuses;
            saveSearchObj.filterOwners = this.filterOwners;
            saveSearchObj.filterCountries = this.filterCountries;
            saveSearchObj.filterSviStatuses = this.filterSviStatuses;
            saveSearchObj.filterTeams = this.filterTeams;
            saveSearchObj.filterImts = this.filterImts;
            saveSearchObj.filterIots = this.filterIots;
            saveSearchObj.dynamicColumns = dynamicColumns;
            saveSearchObj.repType = this.repType;
            saveSearchObj.filterType = this.filterType;
            saveSearchObj.sviFromDate = this.sviFromDate;
            saveSearchObj.db2Col = this.db2Col;
            saveSearchObj.genCol = this.genCol;
            saveSearchObj.eligCol = this.eligCol;
            saveSearchObj.valCol = this.valCol;
            if (typeof this.userFilters !== 'undefined') {
                this.userFilters.push(saveSearchObj);
            }
            else {
                this.userFilters = [saveSearchObj];
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'SaveFilter',
                script: '/queueservice/filterprofiles',
                user: this.env.user,
                data: this.userFilters,
                email: this.env.user.email
            }
        });
    };
    ReportingCustomController.prototype.changeSavedFilter = function (filter) {
        this.currFilter = filter;
        this.filterIots = filter.filterIots;
        this.filterImts = filter.filterImts;
        this.filterCountries = filter.filterCountries;
        this.filterSviStatuses = filter.filterSviStatuses;
        this.filterStatuses = filter.filterStatuses;
        this.filterSubStatuses = filter.filterSubStatuses;
        this.filterOwners = filter.filterOwners;
        this.filterTeams = filter.filterTeams;
        if (typeof filter.repType !== 'undefined') {
            this.repType = filter.repType;
        }
        if (typeof filter.repType !== 'undefined') {
            this.filterType = filter.filterType;
        }
        if (typeof filter.sviFromDate !== 'undefined' && filter.sviFromDate !== '') {
            this.sviFromDate = new Date(filter.sviFromDate);
        }
        if (typeof filter.sviToDate !== 'undefined' && filter.sviToDate !== '') {
            this.sviToDate = new Date(filter.sviToDate);
        }
        if (typeof filter.db2Col !== 'undefined') {
            for (var i = 0; i < this.db2Col.length; i++) {
                for (var i2 = 0; i2 < filter.db2Col.length; i2++) {
                    if (this.db2Col[i].name === filter.db2Col[i2].name) {
                        if (!this.db2Col[i].isSelected && filter.db2Col[i2].isSelected) {
                            this.colQty++;
                        }
                        this.db2Col[i].isSelected = filter.db2Col[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.eligCol !== 'undefined') {
            for (var i = 0; i < this.eligCol.length; i++) {
                for (var i2 = 0; i2 < filter.eligCol.length; i2++) {
                    if (this.eligCol[i].name === filter.eligCol[i2].name) {
                        if (!this.eligCol[i].isSelected && filter.eligCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.eligCol[i].isSelected = filter.eligCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.genCol !== 'undefined') {
            for (var i = 0; i < this.genCol.length; i++) {
                for (var i2 = 0; i2 < filter.genCol.length; i2++) {
                    if (this.genCol[i].name === filter.genCol[i2].name) {
                        if (!this.genCol[i].isSelected && filter.genCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.genCol[i].isSelected = filter.genCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.valCol !== 'undefined') {
            for (var i = 0; i < this.valCol.length; i++) {
                for (var i2 = 0; i2 < filter.valCol.length; i2++) {
                    if (this.valCol[i].name === filter.valCol[i2].name) {
                        if (!this.valCol[i].isSelected && filter.valCol[i2].isSelected) {
                            this.colQty++;
                        }
                        this.valCol[i].isSelected = filter.valCol[i2].isSelected;
                        break;
                    }
                }
            }
        }
        if (typeof filter.dynamicColumns !== 'undefined') {
            this.asyncColumns = filter.dynamicColumns;
        }
    };
    ReportingCustomController.prototype.cancel = function (ev) {
        //        this.$mdDialog.cancel();
    };
    ReportingCustomController.prototype.deleteProfile = function (profile) {
        this.allowed = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteProfile',
                script: '/queueservice/filterprofiles',
                user: this.env.user.email,
                data: profile,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ReportingCustomController.prototype.querySearch = function (criteria) {
        this.cachedQuery = this.cachedQuery || criteria;
        return this.cachedQuery ? this.allContacts.filter(this.createFilterFor(this.cachedQuery)) : [];
    };
    ReportingCustomController.prototype.delayedQuerySearch = function (criteria) {
        var _this = this;
        this.cachedQuery = criteria;
        if (!this.pendingSearch || !this.debounceSearch()) {
            this.cancelSearch();
            return this.pendingSearch = this.$q(function (resolve, reject) {
                // Simulate async search... (after debouncing)
                _this.cancelSearch = reject;
                _this.$timeout(function () {
                    resolve(_this.querySearch(criteria));
                    _this.refreshDebounce();
                }, 1000);
            });
        }
    };
    ReportingCustomController.prototype.refreshDebounce = function () {
        this.lastSearch = 0;
        this.pendingSearch = null;
        this.cancelSearch = angular.noop;
    };
    /**
     * Debounce if querying faster than 300ms
     */
    ReportingCustomController.prototype.debounceSearch = function () {
        var now = new Date().getMilliseconds();
        this.lastSearch = this.lastSearch || now;
        return ((now - this.lastSearch) < 300);
    };
    /**
     * Create filter function for a query string
     */
    ReportingCustomController.prototype.createFilterFor = function (query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(contact) {
            return (contact._lowername.indexOf(lowercaseQuery) !== -1);
        };
    };
    ReportingCustomController.prototype.loadContacts = function () {
        var opp = {
            name: 'opp',
            title: 'Opportunity',
            option: 'opp'
        };
        var contacts = this.dynamicColumns;
        /*      let contacts = [
                  {
                      name: 'opp',
                      title: 'Opportunity',
                      option: 'opp, name'
                  },
                  {
                      name: 'brand',
                      title: 'Brand',
                      option: 'brand, name'
                  }
              ];
        */
        return contacts.map(function (c, index) {
            var contact = {
                name: c.name,
                title: c.title,
                option: c.option,
                _lowername: ''
            };
            contact._lowername = contact.title.toLowerCase();
            return contact;
        });
    };
    ReportingCustomController.$inject = ['$scope', 'env', '$filter', '$timeout', '$q', 'socket',
        'DTS', 'DTOptionsBuilder', 'DTColumnBuilder', '_',
        '$compile', '$state', '$stateParams', 'notify', 'Dialog', 'settings'];
    return ReportingCustomController;
}());
var ReportingCustomComponent = (function () {
    function ReportingCustomComponent() {
        this.bindings = bindsToCust;
        this.templateUrl = 'report.custom.html';
        this.controller = ReportingCustomController;
    }
    return ReportingCustomComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportCustom', new ReportingCustomComponent());

//# sourceMappingURL=reporting.custom.component.js.map
